const getTranslatable = (
  fieldType,
  fieldName,
  { companyId, employeeGroupId }
) => {
  const normalizedCompanyId = companyId ?? "default";
  const normalizedEmployeeGroupId = employeeGroupId ?? "default";

  if (["wysiwyg", "textarea", "infinite-input-list"].includes(fieldType)) {
    return {
      code: `configuration:${fieldName}:${normalizedCompanyId}:${normalizedEmployeeGroupId}`,
      isCms: true,
    };
  }
  return {
    scope: `configuration:${fieldName}`,
  };
};

export default getTranslatable;
